<template>
  <share-frame class="dd-celebrate-frame">
    <d-d-celebrate-share-component/>
  </share-frame>
</template>

<script>

import ShareFrame from '@/base-components/share/ShareFrame';
import DDCelebrateShareComponent from './DDCelebrateShareComponent';

export default {
  name: 'DDCelebrateAsset',
  components: {
    ShareFrame,
    DDCelebrateShareComponent,
  },
};

</script>

<style lang="scss" scoped>

.dd-celebrate-frame {
  width: 500px;
}

</style>
